import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

/**
 * Hook per resettare una challenge specifica di un utente
 * @param {Object} options - Opzioni per la mutation
 * @param {Function} options.onSuccess - Callback di successo
 * @param {Function} options.onError - Callback di errore
 * @returns {Object} Mutation object di React Query
 */
export const useResetChallenge = (options = {}) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ username, challengeType }) => {
      const response = await restClient({
        url: `${prefix}/challenge/reset`,
        method: 'post',
        data: {
          username,
          challengeType
        }
      });
      return response;
    },
    onSuccess: async (data, variables) => {
      // Chiama il callback di successo se fornito
      if (options.onSuccess) {
        await options.onSuccess(data, variables);
      }
    },
    onError: (error, variables) => {
      console.error('Error resetting challenge:', error);
      
      // Chiama il callback di errore se fornito
      if (options.onError) {
        options.onError(error, variables);
      }
    },
    ...options
  });
};
